import { HelmetProvider, Helmet } from 'react-helmet-async'
import { useGetClient } from '../utils/hooks/auth.hooks'

export const CustomHelmet = () => {
    const { data: clientId } = useGetClient()
    // TODO: Change these according to the environment
    const CLIENT_CUSTOM_CSS_URL = `${window.location.origin === 'http://localhost:5173' ? 'https://dev.customerportal.bms.my.broadlume.com' : window.location.origin}/${clientId}/css/custom-theme.css?v=${new Date().getTime()}`
    const CLIENT_CUSTOM_LOGO = `${window.location.origin === 'http://localhost:5173' ? 'https://dev.customerportal.bms.my.broadlume.com' : window.location.origin}/${clientId}/data/images/logo.png`

    return (
        <HelmetProvider>
            <Helmet>
                <link
                    rel="icon"
                    type="image/svg+xml"
                    href={CLIENT_CUSTOM_LOGO}
                />
                <link href={CLIENT_CUSTOM_CSS_URL} rel="stylesheet"></link>
            </Helmet>
        </HelmetProvider>
    )
}
